(function () {
  if (customElements.get('ce-product') !== undefined) {
    return;
  }

  class Product extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.options = {
        main: this.hasAttribute('main') || false,
      };

      this.selectors = {
        product: 'ce-product',
        form: 'form',
        json: '[data-product-json]',
        toaster: 'ce-toaster',
      };

      this.elements = null;
      this.variantOptions = null;

      this._handleSubmitForm = this._handleSubmitForm.bind(this);
    }

    get isLoading() {
      return this.getAttribute('is-loading') === 'true';
    }

    set isLoading(value) {
      this.setAttribute('is-loading', value);
    }

    get option1() {
      return this.getAttribute('option-1');
    }

    set option1(value) {
      this.setAttribute('option-1', value);
    }

    get option2() {
      return this.getAttribute('option-2');
    }

    set option2(value) {
      this.setAttribute('option-2', value);
    }

    get option3() {
      return this.getAttribute('option-3');
    }

    set option3(value) {
      this.setAttribute('option-3', value);
    }

    get sellingPlanId() {
      return this.getAttribute('selling-plan-id');
    }

    set sellingPlanId(value) {
      this.setAttribute('selling-plan-id', value);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['is-loading', 'option-1', 'option-2', 'option-3', 'variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-loading':
          if (newValue !== null) {
            this.dispatchEvent(new CustomEvent('ce-product:is-loading', { detail: newValue }));
          }
          break;
        case 'option-1':
          if (newValue !== null) {
            this.dispatchEvent(new CustomEvent('ce-product:option-1', { detail: { position: 0, value: newValue } }));
          }
          break;
        case 'option-2':
          if (newValue !== null) {
            this.dispatchEvent(new CustomEvent('ce-product:option-2', { detail: { position: 1, value: newValue } }));
          }
          break;
        case 'option-3':
          if (newValue !== null) {
            this.dispatchEvent(new CustomEvent('ce-product:option-3', { detail: { position: 2, value: newValue } }));
          }
          break;
        case 'variant-id':
          if (newValue !== null) {
            this._setUrlWithVariant(newValue);
            this.dispatchEvent(new CustomEvent('ce-product:variant-id', { detail: newValue }));

            this._setOptionsWithVariantId(newValue);
          }
          break;
      }
    }

    parsedCallback() {
      this.elements = {
        products: document.querySelectorAll(this.selectors.product),
        form: this.querySelector(this.selectors.form),
        json: this.querySelector(this.selectors.json),
        toaster: document.querySelector(this.selectors.toaster),
      };

      this.variantOptions = JSON.parse(this.elements.json.textContent);
      this.elements.json.remove();

      this.elements.form.addEventListener('submit', this._handleSubmitForm);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.form.removeEventListener('submit', this._handleSubmitForm);
    }

    async _handleSubmitForm(event) {
      event.preventDefault();

      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        const requestBody = new FormData(this.elements.form);
        requestBody.append('sections', ['cart-data', 'cart-drawer', 'cart-drawer-notification']);

        const response = await fetch(Themu.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
          },
          body: requestBody,
        });

        if (!response.ok) {
          const responseBody = await response.json();
          this.elements.toaster.makeToast('warning', responseBody.description, 7000);
          throw Error;
        }

        const responseBody = await response.json();

        document.dispatchEvent(new CustomEvent('Themu:cart:add', { detail: responseBody.sections }));

        this.elements.toaster.makeToast('success', Themu.t.products.buy_buttons.success_message);
      } catch (error) {
        this.elements.toaster.makeToast('danger', Themu.t.products.buy_buttons.error_message, 7000);
      } finally {
        this.isLoading = false;
      }
    }

    _setUrlWithSellingPlan(id) {
      if (!this.options.main) {
        return;
      }

      let searchParams = new URLSearchParams(window.location.search);

      if (id === '-1') {
        searchParams.delete('selling_plan');
      } else {
        searchParams.set('selling_plan', id);
      }

      const url = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState(null, '', url);
    }

    _setUrlWithVariant(id) {
      if (!this.options.main) {
        return;
      }

      let searchParams = new URLSearchParams(window.location.search);

      searchParams.set('variant', id);

      const url = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState(null, '', url);
    }

    _setOptionsWithVariantId(id) {
      const { option1, option2, option3 } = this.variantOptions.find((v) => v.id === parseInt(id));

      this.option1 = option1;
      this.option2 = option2;
      this.option3 = option3;
    }

    setSellingPlanWithId(id) {
      this.sellingPlanId = id;

      this._setUrlWithSellingPlan(this.sellingPlanId);
      this.dispatchEvent(new CustomEvent('ce-product:selling-plan-id', { detail: this.sellingPlanId }));
    }

    setVariantWithId(id) {
      this.variantId = id;
    }

    setVariantWithOptions(options) {
      const variant = this.variantOptions.find((v) => v.option1 === options[0] && v.option2 === options[1] && v.option3 === options[2]);

      if (variant === undefined) {
        return;
      }

      this.variantId = variant.id;
    }
  }

  customElements.define('ce-product', Product);
})();
